import { useEffect, useState } from 'react';
import Router from 'next/router';

export interface IRouteChangeListener {
  isRouteChangeStarted: boolean;
  isRouteChangeComplete: boolean;
  isRouteChangeError: boolean;
}

const useRouteChangeListener = () => {
  const [routeState, setRouteState] = useState<IRouteChangeListener>({
    isRouteChangeComplete: false,
    isRouteChangeError: false,
    isRouteChangeStarted: false,
  });

  const routeChangeStart = () => {
    setRouteState({
      isRouteChangeComplete: false,
      isRouteChangeError: false,
      isRouteChangeStarted: true,
    });
  };

  const routeChangeComplete = () => {
    setRouteState({
      isRouteChangeError: false,
      isRouteChangeComplete: true,
      isRouteChangeStarted: false,
    });
  };

  const routeChangeError = () => {
    setRouteState({
      isRouteChangeError: true,
      isRouteChangeComplete: false,
      isRouteChangeStarted: false,
    });
  };

  useEffect(() => {
    Router.events.on('routeChangeStart', routeChangeStart);
    Router.events.on('routeChangeComplete', routeChangeComplete);
    Router.events.on('routeChangeError', routeChangeError);
    return () => {
      Router.events.off('routeChangeStart', routeChangeStart);
      Router.events.off('routeChangeComplete', routeChangeComplete);
      Router.events.off('routeChangeError', routeChangeError);
    };
  }, []);

  return routeState;
};

export { useRouteChangeListener };
